import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../../../ressources/styles/anchornav.css";

export default function AnchorNav({SECTIONS}) {
  const { t } = useTranslation();
  const [active, setActive] = useState("section-accueil");

  useEffect(() => {
    const updateActive = () => {
      const middle = window.innerHeight / 2;
      let best = null;
      let bestDist = Infinity;

      SECTIONS.forEach(({ id }) => {
        const el = document.getElementById(id);
        if (!el) return;

        const rect = el.getBoundingClientRect();
        const distToMiddle = Math.abs(rect.top - middle);

        if (rect.top <= middle && distToMiddle < bestDist) {
          bestDist = distToMiddle;
          best = id;
        }
      });

      if (best) setActive(best);
    };

    window.addEventListener("scroll", updateActive, { passive: true });
    updateActive(); // init au montage

    return () => window.removeEventListener("scroll", updateActive);
  }, [SECTIONS]);

  const handleClick = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav className="anchor-nav" aria-label="Navigation sections">
      {SECTIONS.map(({ id, labelKey }) => (
        <button
          key={id}
          className={`anchor-nav__item${active === id ? " anchor-nav__item--active" : ""}`}
          onClick={() => handleClick(id)}
          aria-label={t(labelKey)}
        >
          <span className="anchor-nav__label">{t(labelKey)}</span>
          <span className="anchor-nav__dot" />
        </button>
      ))}
    </nav>
  );
}